import React from 'react';
import { Mail, Phone, Globe } from 'lucide-react';

export const SOCIAL_PLATFORMS = [
    {
        key: 'tiktok',
        label: 'TikTok',
        labelAr: 'تيك توك',
        color: '#fe2c55',
        bgColor: 'rgba(254, 44, 85, 0.12)',
        borderColor: 'rgba(254, 44, 85, 0.35)',
        placeholder: 'https://www.tiktok.com/@your-store',
        icon: (size = 18) => (
            <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.589 6.686a4.793 4.793 0 0 1-3.77-4.245V2h-3.445v13.672a2.896 2.896 0 0 1-2.891 2.891 2.896 2.896 0 0 1-2.891-2.891 2.896 2.896 0 0 1 2.891-2.891c.31 0 .607.05.885.14V9.458a6.326 6.326 0 0 0-.885-.062C5.932 9.396 3 12.328 3 15.772 3 19.216 5.932 22 9.482 22c3.55 0 6.482-2.784 6.482-6.228V8.673a8.214 8.214 0 0 0 4.625 1.418V6.686z" />
            </svg>
        )
    },
    {
        key: 'instagram',
        label: 'Instagram',
        labelAr: 'إنستغرام',
        color: '#e1306c',
        bgColor: 'rgba(225, 48, 108, 0.12)',
        borderColor: 'rgba(225, 48, 108, 0.35)',
        placeholder: 'https://instagram.com/your-store',
        icon: (size = 18) => (
            <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
            </svg>
        )
    },
    {
        key: 'facebook',
        label: 'Facebook',
        labelAr: 'فيسبوك',
        color: '#1877f2',
        bgColor: 'rgba(24, 119, 242, 0.12)',
        borderColor: 'rgba(24, 119, 242, 0.35)',
        placeholder: 'https://facebook.com/your-store',
        icon: (size = 18) => (
            <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
            </svg>
        )
    },
    {
        key: 'whatsapp',
        label: 'WhatsApp',
        labelAr: 'واتساب',
        color: '#25d366',
        bgColor: 'rgba(37, 211, 102, 0.12)',
        borderColor: 'rgba(37, 211, 102, 0.35)',
        placeholder: 'https://wa.me/XXXXXXXXXXX',
        icon: (size = 18) => (
            <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
                <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
            </svg>
        )
    },
    {
        key: 'twitter',
        label: 'X (Twitter)',
        labelAr: 'منصة إكس (X)',
        color: '#ffffff',
        bgColor: 'rgba(255, 255, 255, 0.12)',
        borderColor: 'rgba(255, 255, 255, 0.35)',
        placeholder: 'https://x.com/your-store',
        icon: (size = 18) => (
            <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
            </svg>
        )
    },
    {
        key: 'youtube',
        label: 'YouTube',
        labelAr: 'يوتيوب',
        color: '#ff0000',
        bgColor: 'rgba(255, 0, 0, 0.12)',
        borderColor: 'rgba(255, 0, 0, 0.35)',
        placeholder: 'https://youtube.com/@your-store',
        icon: (size = 18) => (
            <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
            </svg>
        )
    },
    {
        key: 'snapchat',
        label: 'Snapchat',
        labelAr: 'سناب شات',
        color: '#fffc00',
        bgColor: 'rgba(255, 252, 0, 0.12)',
        borderColor: 'rgba(255, 252, 0, 0.35)',
        placeholder: 'https://www.snapchat.com/add/your-store',
        icon: (size = 18) => (
            <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
                <path d="M12.003 2c-3.666 0-6.19 2.584-6.19 6.208 0 .848.212 2.057.247 2.21.066.287-.234.428-.432.483-.497.138-1.282.47-1.573 1.157-.27.636.082 1.306.91 1.748.217.116.486.223.59.39.124.2-.007.604-.467.975-.595.48-1.42 1.378-1.042 2.378.334.88 1.488 1.144 2.825.868.514-.106.942-.036 1.32.222.61.417 1.134 1.361 3.812 1.361 2.678 0 3.202-.944 3.812-1.361.378-.258.806-.328 1.32-.222 1.337.276 2.491.012 2.825-.868.378-1-.447-1.898-1.042-2.378-.46-.371-.591-.775-.467-.975.104-.167.373-.274.59-.39.828-.442 1.18-1.112.91-1.748-.291-.687-1.076-1.019-1.573-1.157-.198-.055-.498-.196-.432-.483.035-.153.247-1.362.247-2.21C18.193 4.584 15.669 2 12.003 2z" />
            </svg>
        )
    },
    {
        key: 'telegram',
        label: 'Telegram',
        labelAr: 'تيليجرام',
        color: '#229ed9',
        bgColor: 'rgba(34, 158, 217, 0.12)',
        borderColor: 'rgba(34, 158, 217, 0.35)',
        placeholder: 'https://t.me/your_channel',
        icon: (size = 18) => (
            <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
            </svg>
        )
    }
];

export const getSocialIcon = (key, size = 18) => {
    const platform = SOCIAL_PLATFORMS.find(p => p.key.toLowerCase() === key.toLowerCase());
    if (platform) return platform.icon(size);
    if (key === 'email') return <Mail size={size} />;
    if (key === 'phone') return <Phone size={size} />;
    return <Globe size={size} />;
};

export const getSocialMeta = (key) => {
    return SOCIAL_PLATFORMS.find(p => p.key.toLowerCase() === key.toLowerCase()) || null;
};
